module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres6ae"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHres6aeIndex,
      "searchBoxAlias": "request",
      "maxRowspan": _vm.maxRowspan.index,
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent,
      "unLoadBool": true
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "detail": _vm.detail,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "postHres6aeSave": _vm.postHres6aeSave,
      "columnsDetail": _vm.columns[_vm.app.nowLang].detail,
      "columnsDetailPopup": _vm.columns[_vm.app.nowLang].detailPopup,
      "indexSelected": _vm.indexSelected,
      "receivedHres6aeDetailSearch": _vm.receivedHres6aeDetailSearch,
      "maxRowspanDetail": _vm.maxRowspan.detail,
      "maxRowspanPopup": _vm.maxRowspan.detailPopup,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex,
      "saveButtonDisp": _vm.saveButtonDisp
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e97260ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6ae/component.vue
// module id = 4007
// module chunks = 1